import type { State } from "../State";
import { restorePdfConfig, type PdfApplicationMode, type PdfExportConfig } from "./PdfExportConfig";

/** Restores document options, using legacy project flags only when no document value was saved. */
export function readPdfExportConfig(app: State, mode: PdfApplicationMode): PdfExportConfig {
  const stored = mode === "main" ? app.settings.masterPdfConfig : app.c1Project.masterPdfConfig;
  const config = restorePdfConfig(mode, stored, app.projectMetadata?.isC1Project !== false);
  if (app.projectMetadata?.isC1Project) {
    const floorPlans = config.chapters.find(chapter => chapter.id === "floorPlans");
    if (floorPlans && floorPlans.includeDimensions === undefined) {
      const projectFloorPlans = app.c1Project?.masterPdfConfig?.chapters.find(chapter => chapter.id === "floorPlans");
      floorPlans.includeDimensions = projectFloorPlans?.includeDimensions ?? true;
    }
  }
  if (mode !== "main") return config;
  for (const chapter of config.chapters) {
    const savedChapter = stored?.chapters.find(saved => saved.id === chapter.id);
    if (chapter.id === "productPrices" && savedChapter?.pricesPerCabinet === undefined) {
      chapter.pricesPerCabinet = app.projectMetadata?.priceListOneCabinetOnePage ?? chapter.pricesPerCabinet;
    }
    if (chapter.id === "cablePull" && savedChapter?.cablePullCounts === undefined) {
      chapter.cablePullCounts = app.projectMetadata?.showCablePullListCableInfos ?? chapter.cablePullCounts;
    }
  }
  return config;
}

/** Saves selection and order independently for the two application shells. */
export function savePdfExportConfig(app: State, mode: PdfApplicationMode, config: PdfExportConfig): PdfExportConfig {
  const normalized = restorePdfConfig(mode, config, app.projectMetadata?.isC1Project !== false);
  if (mode === "main") app.settings.masterPdfConfig = normalized;
  else app.c1Project.setMasterPdfConfig(normalized);
  return normalized;
}
